import { render, staticRenderFns } from "./PaginatedAutocompleteMulti.vue?vue&type=template&id=48d43a35&scoped=true&"
import script from "./PaginatedAutocompleteMulti.vue?vue&type=script&lang=js&"
export * from "./PaginatedAutocompleteMulti.vue?vue&type=script&lang=js&"
import style0 from "./PaginatedAutocompleteMulti.vue?vue&type=style&index=0&id=48d43a35&prod&scoped=true&lang=css&"
import style1 from "./PaginatedAutocompleteMulti.vue?vue&type=style&index=1&id=48d43a35&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d43a35",
  null
  
)

export default component.exports